import { useEffect, useState } from "react";
import axios from "@helpers/axios/private.axios";

export const useSessions = () => {
    const [sessions, setSessions] = useState([]);
    const [loading, setLoading] = useState(true);

    const hasValidIp = (session) => {
        return typeof session?.ip === "string" && session.ip.trim().length > 0;
    };

    useEffect(() => {
        const fetchSessions = async () => {
            try {
                setLoading(true);

                const response = await axios.get("/users/security/sessions");

                const sessionsData = response.data?.data?.sessions || [];
                const filteredSessions = sessionsData.filter(hasValidIp);

                setSessions(filteredSessions);
            } catch (error) {
                console.error("Failed to fetch active sessions:", error);
                setSessions([]);
            } finally {
                setLoading(false);
            }
        };

        fetchSessions();
    }, []);

    return {
        sessions,
        loading
    };
};